export default __webpack_public_path__ + "static/vue-icon-e4bd3069d01b866a785944f12cdaf110.svg";